import { IconButton } from '~components/IconButton';
import { P } from '~components/Typography';
import { NsfwReason, RegisterInbound } from '~features/annals';
import { ButtonInline } from '~shared/ui/molecules';

import CloseIcon from '../../../../../public/assets/icons/close.svg';
import { useCanShowSafeModeSwitchingPopup } from '../../hooks/useSafeModeSwitchingPopup';
import { useSwitchSafeModeWithAgeValidation } from '../../hooks/useSwitchSafeMode';
import { Container, DescriptionContainer, Title } from './styles';

export const NSFWExploreNotice = () => {
	const { popupVisible, closePopup } = useCanShowSafeModeSwitchingPopup();
	const updateSafeMode = useSwitchSafeModeWithAgeValidation();

	const handleClick = () => {
		void updateSafeMode(false, {
			force: true,
			nsfwReason: NsfwReason.Grid,
			registerInbound: RegisterInbound.GridNsfwSearchSwitch,
		});
	};

	if (!popupVisible) {
		return undefined;
	}

	return (
		<Container>
			<IconButton onClick={closePopup}>
				<CloseIcon />
			</IconButton>
			<DescriptionContainer>
				<Title>NSFW Search results are hidden</Title>
				<P align={'left'} size={'small'} weight={400}>
					Not safe for work(NSFW) results may contains sensitive or adult
					content.
				</P>
			</DescriptionContainer>

			<ButtonInline
				text="View NSFW Results"
				size="small"
				weight={500}
				brandColor={true}
				underline={true}
				onClick={handleClick}
			/>
		</Container>
	);
};
